import ColoredBar from '@/stories/components/Common/ColoredBar'
import { randomColorArray } from '@/root/utils/common/numbers/get-random-color-code'
import {
  MarketCapBreakUp,
  SectorBreakUp,
} from '@/components/Stocks/Widgets/types'

const MarketBreakup = ({
  market_cap,
  sector_breakup,
}: {
  market_cap: MarketCapBreakUp[]
  sector_breakup: SectorBreakUp[]
}) => {
  const data = [
    {
      title: 'Sector',
      data: sector_breakup.map(item => {
        return {
          label: item.sector,
          perc: item.proportion,
        }
      }),
      stacked: true,
      selected: true,
    },
    {
      title: 'Market Cap',
      data: market_cap.map(item => {
        return {
          label: item.market_cap,
          perc: item.proportion,
        }
      }),
      stacked: false,
      selected: false,
    },
  ]

  return (
    <div>
      <h2 className="mb-6 w-full border-b-[0.5px] pb-6 text-xl font-medium lg:text-2xl">
        Portfolio Breakup
      </h2>

      <div className="flex flex-col gap-16 md:flex-row md:gap-20">
        {data.map((item, idx) => (
          <div className="w-full md:w-1/2" key={idx}>
            <ColoredBar
              heading={item.title}
              bars={item.data.map((item, idx) => {
                return {
                  name: item.label,
                  perc: `${item.perc}%`,
                  color: randomColorArray[idx],
                }
              })}
              stacked={item.stacked}
            />
          </div>
        ))}
      </div>
    </div>
  )
}

export default MarketBreakup
